import { BrowserRouter, matchPath } from 'react-router-dom';
import './i18n/init';
import './beforeRender';
import { CommonRouter, CurrentUser, ErrorPage, http, utils } from '@common';
import { studentAuthRouterPaths, adminAuthRouterPaths, routerPaths } from './tool';
import Home from './home';
import OauthManagement from './oauth/router';
import AdminRouter from './admin/router';
import StudentRouter from './student/router';
import { transferService, accountService } from "@api";
import ChangePassword from './component/changePassword';
import sixLogos from "@image/STEP-stmslogo.png";
import './content';

const params = utils.geturlparam(window?.location.search);
const pathName = window.location.pathname;

export const routers = [
    { path: "/error/403", exact: true, component: ErrorPage.Forbidden },
    { path: "/error/404", exact: true, component: ErrorPage.NotFound },
    { path: "/error/500", exact: true, component: ErrorPage.InteralServerError },
    { path: "/error/urlexpired", exact: true, component: ErrorPage.UrlExpired },
    { path: "/error/400", exact: true, component: ErrorPage.BadRequest },
    { path: "/success/logout", exact: true, component: ErrorPage.LogoutSuccessful },
    { path: "/error/studentsessionexpired", exact: true, component: ErrorPage.StudentSessionExpired },
    {
        path: routerPaths.home,
        exact: true,
        render: props => <Home {...props} /> //props => !CurrentUser.isGlobal ? <Home {...props} /> : <Redirect to={routerPaths.admin} />,
    },
    {
        path: routerPaths.oauth,
        component: OauthManagement,
    },
    {
        path: routerPaths.admin,
        component: AdminRouter,
    },
    {
        path: routerPaths.student,
        component: StudentRouter,
    },
    {
        path: routerPaths.changePassword,
        component: ChangePassword,
        exact: true,
    }
];


export default class RouterProd extends R.Component {
    render() {
        return (
            <RootRouter routers={routers} prod={true} />

        );
    }
}

export class RootRouter extends R.Component {
    componentCreate() {
        this.state = {
            loaded: false,
            navigations: [],
        };
    }
    async componentInit() {
        const { obj } = params;
        $$.loading(true);
        window.wogaaCustom?.startTransactionalService('cispoliteedu-4703');
        const res = await transferService.getTransferData({ proxyState: obj?.proxyState });
        sessionStorage.setItem('transferData', JSON.stringify(res));
        $$.loading(false);
        // if ([...studentAuthRouterPaths, ...adminAuthRouterPaths].includes(pathName.split('/cis')[1] ?? pathName)) {
        if ([...studentAuthRouterPaths, ...adminAuthRouterPaths].includes(pathName.split('/cis')[1] ?? pathName) || [...studentAuthRouterPaths, ...adminAuthRouterPaths].some(path => matchPath(pathName.split("/cis")[1], { path }))) {
            const fromAdmin = adminAuthRouterPaths.includes(pathName.split('/cis')[1] ?? pathName) || [...adminAuthRouterPaths].some(path => matchPath(pathName.split("/cis")[1], { path }));
            const AzureAD = fromAdmin && JSON.parse(sessionStorage['transferData'])?.detail?.AzureAD?.logicalName;
            this.getAuth(AzureAD);
        } else {
            this.setState({ loaded: true });
        }
    }

    getAuth(adminLogical = '') {
        $$.loading(true);
        accountService.getCurrentUser().then(async res => {
            $$.loading(false);
            if (res) {
                const result = await utils.roleRouter.check(res?.detail?.role);
                CurrentUser.setCurrentUser(res?.detail, res?.detail?.role);
                if (result) {
                    this.setState({ loaded: true });
                }
            }
        }).catch(err => {
            const { search } = params;
            if (err?.errorCode === http.ErrorCode.CodeError) {
                accountService.regoLogin(`${utils.getOriginUrl()}${pathName}${search ?? ""}`, adminLogical || '').then((res) => {
                    utils.redirectTo(res?.detail);
                });
            }
            $$.loading(false);
        });
    }

    render() {
        const { loaded } = this.state;
        const { routers } = this.props;
        const path = pathName?.split('/cis')[1]?.split('/')[1] ? '/' + pathName?.split('/cis')[1]?.split('/')[1] : pathName;
        const needHeader = path === routerPaths.home || path === routerPaths.oauth || path === routerPaths.changePassword || path === routerPaths.cisHome;
        return (
            !loaded ? null : (<BrowserRouter basename={window._resourcePrefix}>
                <CommonRouter routers={routers} needHeader={needHeader} headerIcon={sixLogos} IconClick={() => utils.redirectTo('/student')} />
            </BrowserRouter>)
        );
    }
}
